import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import Loader from "@/components/loader";
import { billableKeys } from "@/modules/work/billables/queries";
import { fetchBillableMeta } from "@/modules/work/billables/api";

const BillableContext = createContext(null);

export const BillableProvider = ({ billableId: propBillableId, children }) => {
  const params = useParams();
  const billableId = propBillableId ?? params.billableId;

  const { data, isLoading, isError, error, refetch } = useFetch({
    queryKey: billableKeys.meta(billableId),
    queryFn: () => fetchBillableMeta({ billableId }),
  });

  if (isLoading) return <Loader />;
  if (isError)
    return (
      <div className="p-4 text-red-600">
        {error?.message || "Error loading billable"}
      </div>
    );

  const value = {
    billableId,
    billable: data,
    job: data.job,
    project: data.job.project,
    type: data.type,
    refetch,
  };

  return (
    <BillableContext.Provider value={value}>
      {children}
    </BillableContext.Provider>
  );
};

export const useBillable = () => {
  const ctx = useContext(BillableContext);
  if (!ctx) {
    throw new Error("useBillable must be used within a BillableProvider");
  }
  return ctx;
};
